<template>
    <f7-page :routes="routes">
        <f7-navbar title="not found" back-link="Back" :routes="routes"></f7-navbar>
        <f7-block strong>
            <p>404</p>
            <p>Requested content not found</p>
        </f7-block>
    </f7-page>
</template>

<script>
    import routes from '../../routes';

    export default {
        data() {
            return {
                routes
            }
        }
    };
</script>